import { render, staticRenderFns } from "./RegDaan.vue?vue&type=template&id=e3a8577a&scoped=true"
import script from "./RegDaan.vue?vue&type=script&lang=js"
export * from "./RegDaan.vue?vue&type=script&lang=js"
import style0 from "./RegDaan.vue?vue&type=style&index=0&id=e3a8577a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a8577a",
  null
  
)

export default component.exports